import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as Types from '../types/index';
import {formatCurrency} from '../utils/currency';
import QtySelect from './QtySelect';
import StatusLabel from './StatusLabel';

class Product extends Component {
  render () {
    const product = this.props.product;
    return(
      <div className="cart-item">
        <div className="row">
          <div className="small-3 columns">
            <div className="cart-item__image">
              <a href={`${ROOT_URL}/product_detail.php?itemid=${product.id}&catid=${product.catId}`}>
                <img src={`${ROOT_URL}/uploads/products/${product.image}`} />
              </a>
            </div>
          </div>

          <div className="small-5 columns">
            <p className="cart-item__name">
              <a href={`${ROOT_URL}/product_detail.php?itemid=${product.id}&catid=${product.catId}`} dangerouslySetInnerHTML={{__html: product.name}}/>
            </p>
            <p className="cart-item__status">
              <StatusLabel remainingStock={product.remainingStock}
                           isDiscontinued={product.isDiscontinued}
                           isComingSoon={product.isComingSoon}
                           callForPricing={product.callForPricing}
                           specialShipDate={product.specialShipDate}
                           specialShipDays={product.specialShipDays}
                           backorderShipDate={product.backorderShipDate}
                           backorderShipDays={product.backorderShipDays}/>
            </p>
            <span className="cart-item__actions">
              <a onClick={e => this.props.onDelete(product.id)}>Delete</a>
              <span> &nbsp; | &nbsp; </span>
              <a onClick={e => this.props.onSaveForLater(product.id)}>Save for later</a>
            </span>
          </div>

          <div className="small-2 columns">
            <p className={'cart-item__price' + (product.isCustomerPrice ? ' -is-customer-price' : '')}>{formatCurrency(product.salePrice || product.price)}</p>
          </div>

          <div className="small-2 columns">
            <QtySelect value={product.qty} onChange={qty => this.props.onQtyChange(product.id, qty)}/>
          </div>
        </div>
      </div>
    );
  }
}

Product.propTypes = {
  product: Types.product.isRequired,
  onQtyChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onSaveForLater: PropTypes.func.isRequired,
};

export default Product;
